import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { Observable } from 'rxjs/Observable';

const CACHE_TIME: number = 3600;

export class OTAClientPlugin extends SmartenitPlugin {
  // Attributes

  get version(): string {
    return this.state.version;
  }

  get processedVersion(): string {
    return this.state.processedVersion;
  }

  public readVersion() {
    ['CurrentFileVersion', 'ProcessedVersion'].forEach((v) => {
      this.getAttributeWithSubscribeOption(
        this.componentId,
        this.processorName,
        v,
        null,
        false,
        `cacheTTL=${this.stateTTL}`
      );
    });
  }

  // General

  get stateTTL(): number {
    return CACHE_TIME;
  }

  public getStatusPayload(): any {
    return ['CurrentFileVersion', 'ProcessedVersion'];
  }

  public getStatus(
    context?: string,
    force?: boolean,
    asObservable?: boolean,
    payload?: any,
    sendDirect: boolean = false
  ) {
    if (payload && Object.keys(payload).length > 0) {
      payload = Object.assign(this.getStatusPayload(), payload);
    } else {
      payload = this.getStatusPayload();
    }

    this.device.getStatus(
      this.componentId,
      this.processorName,
      payload,
      'cached=false',
      sendDirect
    );
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'CurrentFileVersion') {
      this.state.version = response.value != null ? response.value : '-';

      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ProcessedVersion') {
      this.state.processedVersion =
        response.value != null ? response.value : '-';

      this._onUpdate.next({ state: this.state });
    }

    return this.state;
  }
}
